<script setup lang="ts">
type Props = {
  totalTime: number;
  progressBar?: boolean;
  restart?: boolean;
};

const {
  totalTime,
  progressBar = false,
  restart = false,
} = defineProps<Props>();

type Emits = {
  timerEnded: [];
  timerFinished: [];
};

const $emit = defineEmits<Emits>();

const countdownActive = ref(true);
const layout = useLayoutStore();
const localTime = ref(totalTime);
const hours = ref('00');
const minutes = ref('00');
const seconds = ref('00');
const started = ref(false);
const progressBarWidth = ref('100%');
const openedModal = ref(false);

const time = computed(() => {
  return {
    hours: hours.value,
    minutes: minutes.value,
    seconds: seconds.value,
  };
});

watch(
  () => totalTime,
  (newVal) => {
    localTime.value = newVal;
    /* if (newVal !== 0) {
      startCountdown();
    } */
  },
);

const countdownInterval = ref();

function startCountdown() {
  started.value = true;
  countdownInterval.value = setInterval(() => {
    countdownActive.value = true;
    localTime.value--;

    hours.value = Math.floor(localTime.value / 3600)
      .toString()
      .padStart(2, '0');
    minutes.value = Math.floor((localTime.value % 3600) / 60)
      .toString()
      .padStart(2, '0');
    seconds.value = Math.floor(localTime.value % 60)
      .toString()
      .padStart(2, '0');

    const percentage = (localTime.value / totalTime) * 100;

    progressBarWidth.value = `${percentage}%`;
  }, 1000);
}

function stopTimer() {
  if (countdownInterval.value !== null) {
    clearInterval(countdownInterval.value);
  }
  countdownActive.value = false;
  $emit('timerEnded');

  if (restart) {
    const initialTime = localStorage.getItem('init_countdown');

    if (initialTime) {
      localTime.value = Number(initialTime);
    }
    countdownActive.value = true;
    startCountdown();
  }
}

watch(
  () => localTime.value,
  (newVal) => {
    if (newVal <= 0) {
      stopTimer();
      if (typeof $emit === 'function') {
        $emit('timerFinished');
      }
    }
  },
  { immediate: true },
);

onMounted(() => {
  if (totalTime !== 0) {
    startCountdown();
  }

  layout.isModalOpen ? (openedModal.value = true) : (openedModal.value = false);
});

onUnmounted(() => {
  stopTimer();
  if (openedModal.value && layout.modalType === 'deposit') {
    localStorage.setItem('start_countdown', JSON.stringify(time.value));
  }
});
</script>

<template>
  <div v-if="started">
    <template v-if="countdownActive">
      <slot
        name="process"
        :time="time"
      >
        <p>{{ hours }} : {{ minutes }} : {{ seconds }}</p>
      </slot>
      <slot
        v-if="progressBar"
        name="progress"
      >
        <div class="progress-bar">
          <div :style="{ width: progressBarWidth }"></div>
        </div>
      </slot>
    </template>
    <template v-else>
      <slot name="finish">
        <!-- Countdown Ended -->
      </slot>
    </template>
  </div>
</template>

<style scoped lang="scss">
.progress-bar {
  @apply bg-bg-secondary mt-1 rounded-md h-1 w-full relative;

  div {
    @apply h-full bg-primary rounded-md;
  }
}
</style>
